/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiChangePasswordWithCodeRequestFromJSON(json) {
    return ApiChangePasswordWithCodeRequestFromJSONTyped(json, false);
}
export function ApiChangePasswordWithCodeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'confirmation': !exists(json, 'confirmation') ? undefined : json['confirmation'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}
export function ApiChangePasswordWithCodeRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'confirmation': value.confirmation,
        'password': value.password,
    };
}
